module.exports = __webpack_public_path__ + "img/go5.f4fdaa7b.jpg";